function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _ from 'lodash';
import moment from 'moment';
import { daysOfWeek } from 'shared/constants/time';
/**
 * Checks if the window has an orientation property, which
 * should be a more robust way to tell if a device is mobile
 * than using screen size. This should be used in situations
 * where an element's visibility and/or position property (i.e. sticky,
 * relative, absolute) is dependent on whether it is mobile
 * (but not necessarily dependent on screen size).
 * Responsive spacing should still be done with @media since it
 * is screen size dependent rather than mobile vs. desktop dependent.
 */ export var isMobile = function() {
    return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
};
export var isIOS = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') {
        return false;
    }
    var ua = navigator.userAgent;
    var isAppleDevice = /iPad|iPhone|iPod/.test(ua);
    var isMacWithTouch = /Macintosh/.test(ua) && navigator.maxTouchPoints > 2;
    return isAppleDevice || isMacWithTouch;
};
export var pluralize = function(stem, count) {
    var postfix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 's';
    return count > 1 || count === 0 ? stem + postfix : stem;
};
export var isValidEmail = function(email) {
    // eslint-disable-next-line max-len
    var re = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
export var isValidHttpUrl = function(string) {
    try {
        var url = new URL(string);
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (err) {
        console.error(err);
        return false;
    }
};
export var isSEOBot = function() {
    return window.navigator.userAgent.match(/prerender/i);
};
export var randomFunCannabisFacts = function() {
    return _.sample([
        'Both Thomas Jefferson and George Washington grew hemp on their plantations.',
        'Cannabis and Beer are genetic cousins.',
        'According to several researchers, the first e-commerce transaction in history was for cannabis. ',
        'Many historians trace the earliest recorded use of cannabis back to China in 10,000 B.C.',
        'There exists over 200 slang, or "Street names", for cannabis.',
        'In 2009, a man set the world record for smoking joints – 115,000.',
        'The shortest jury deliberation in history was about marijuana usage.',
        'Scientists have confirmed that shakespeare used Marijuana.',
        'Mexico grows the most cannabis in the world.',
        'Marijuana milkshakes, called Bhang, are very popular in India.',
        'Americans grow 22 million pounds of marijuana each year.'
    ]);
};
export var randomOrderConfirmationMessages = function() {
    return _.sample([
        "We've got good news"
    ]);
};
export var randomOrderConfirmedMessages = function() {
    return _.sample([
        "Now that's how it's done"
    ]);
};
export var removeTypename = function(value) {
    if (value === null || value === undefined) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map(function(v) {
            return removeTypename(v);
        });
    }
    if (_instanceof(value, Date)) {
        return value;
    }
    if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === 'object') {
        var newObj = {};
        Object.entries(value).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], v = _param[1];
            if (key !== '__typename') {
                newObj[key] = removeTypename(v);
            }
        });
        return newObj;
    }
    return value;
};
export var convertObjectIDtoString = function(value) {
    if (value === null || value === undefined) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map(function(v) {
            return convertObjectIDtoString(v);
        });
    }
    if (_.isPlainObject(value)) {
        var newObj = {};
        Object.entries(value).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], v = _param[1];
            var _v_constructor;
            if (v && ((_v_constructor = v.constructor) === null || _v_constructor === void 0 ? void 0 : _v_constructor.name) === 'ObjectID') {
                v = v.toString();
            }
            newObj[key] = convertObjectIDtoString(v);
        });
        return newObj;
    }
    return value;
};
export var recursiveKeyWalker = function(value, op) {
    if (value === null || value === undefined) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map(function(v) {
            return recursiveKeyWalker(v, op);
        });
    }
    if (_.isPlainObject(value)) {
        var newObj = {};
        Object.entries(value).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], v = _param[1];
            key = op(key);
            newObj[key] = recursiveKeyWalker(v, op);
        });
        return newObj;
    }
    return value;
};
// convert moment objects to strings
export var formatMoments = function(value) {
    if (value === null || value === undefined) {
        return value;
    }
    if (moment.isMoment(value)) {
        return value.format();
    }
    if (Array.isArray(value)) {
        return value.map(function(v) {
            return formatMoments(v);
        });
    }
    if (_.isPlainObject(value)) {
        var newObj = {};
        Object.entries(value).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], v = _param[1];
            newObj[key] = formatMoments(v);
        });
        return newObj;
    }
    return value;
};
export var findAndReplaceWith = function(collection, predicate, replacement) {
    var index = _.findIndex(collection, predicate);
    var newCollection = index >= 0 ? _.assign([], collection, _define_property({}, index, replacement)) : _to_consumable_array(collection).concat([
        replacement
    ]);
    return newCollection;
};
export var isValidZipCode = function(zipcode) {
    // US
    // Supports common 5 digits (0-9) zip codes as well as less common
    // two part zip codes like 94105-0011 which corisponds to a specific
    // area or neighborhood within a zip code area
    var UsZipRegex = /^\d{5}(-\d{4})?$/;
    // CA
    // The format of a Canadian postal code is LDL DLD where L are alpha characters
    // and D are numeric digits. But there are some exceptions.
    // The letters D, F, I, O, Q and U never appear in a postal code because of their
    // visual similarity to 0, E, 1, 0, 0, and V respectively. In addition to avoiding
    // the six "forbidden" letters W and Z also do not appear as the first
    // letter of a postal code (at least not at present).
    var CaZipRegex = /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ]) ?([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/;
    return UsZipRegex.test(zipcode) || CaZipRegex.test(zipcode);
};
export var nameToParts = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', chopLength = arguments.length > 1 ? arguments[1] : void 0;
    var name1;
    var name2 = '';
    if (name.length > chopLength) {
        var split = chopLength;
        while(name[split] !== ' ' && split > 0){
            split -= 1;
        }
        if (split === 0) {
            split = chopLength;
        }
        name1 = name.slice(0, split);
        name2 = name.slice(split);
    } else {
        name1 = name;
    }
    return [
        name1,
        name2
    ];
};
export var processCentsInput = function(input) {
    // fixes strange leading zero issues on forms
    if (input === 0) {
        return 0;
    }
    return input;
};
export function readFile(file) {
    return _readFile.apply(this, arguments);
}
function _readFile() {
    _readFile = _async_to_generator(function(file) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var reader = new FileReader();
                    reader.onload = resolve;
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                })
            ];
        });
    });
    return _readFile.apply(this, arguments);
}
export var dollarsToCents = function(amountInDollars) {
    var roundAmount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return roundAmount ? Math.round(Number(amountInDollars) * 100) : Math.trunc(Number(amountInDollars) * 100);
};
export var centsToDollars = function(amountInCents) {
    return (Number(amountInCents) / 100).toFixed(2);
};
export var formatAmount = function(amountInCents) {
    if (_.isNil(amountInCents)) {
        return '--';
    }
    var amountInDollars = (Number(amountInCents) / 100).toFixed(2);
    return "$".concat(amountInDollars);
};
export var formatCurrency = function(value, options) {
    var parsedValue = parseFloat(value);
    var locale = _.get(options, 'locale', 'en-US');
    var currency = _.get(options, 'currency', 'USD');
    var trimCents = _.get(options, 'trimCents', false);
    var trimZeroCents = _.get(options, 'trimZeroCents', false);
    var style = 'currency';
    var maximumFractionDigits = trimCents ? 0 : 2;
    var minimumFractionDigits = trimCents ? 0 : 2;
    var formattedValue = new Intl.NumberFormat(locale, {
        style: style,
        currency: currency,
        maximumFractionDigits: maximumFractionDigits,
        minimumFractionDigits: minimumFractionDigits
    }).format(parsedValue);
    if (trimZeroCents) {
        formattedValue = formattedValue.replace(/\.00/g, '');
    }
    return formattedValue;
};
export var getDaysOfWeekFromToday = function(timezone) {
    var today = moment().tz(timezone).startOf('day');
    var todayDayOfWeek = today.day();
    var adjustedDaysOfWeek = _to_consumable_array(daysOfWeek.slice(todayDayOfWeek)).concat(_to_consumable_array(daysOfWeek.slice(0, todayDayOfWeek)));
    return adjustedDaysOfWeek.map(function(dayOfWeek, index) {
        return _object_spread_props(_object_spread({}, dayOfWeek), {
            date: moment(today).add(index, 'days').format('YYYY-MM-DD')
        });
    });
};
export var getCurrentTab = function(location, pages, defaultPageKey) {
    var currentPageKey = _.last(_.split(location.pathname, '/'));
    if (_.find(pages, [
        'key',
        currentPageKey
    ])) {
        return currentPageKey;
    }
    if (defaultPageKey) {
        return defaultPageKey;
    }
    return pages[0].key;
};
export var getTranslationForOrderType = function(t, orderType) {
    var useShortNames = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!t || !orderType) {
        return '';
    }
    if (orderType === 'kiosk') {
        return t('common.kiosk', 'Kiosk');
    }
    if (orderType === 'delivery') {
        return t('common.delivery', 'Delivery');
    }
    if (orderType === 'inStorePickup') {
        return useShortNames ? t('common.inStore', 'In-Store') : t('common.inStorePickup', 'In-Store Pickup');
    }
    if (orderType === 'curbsidePickup') {
        return useShortNames ? t('common.curbside', 'Curbside') : t('common.curbsidePickup', 'Curbside Pickup');
    }
    if (orderType === 'driveThruPickup') {
        return useShortNames ? t('common.driveThru', 'Drive-Thru') : t('common.driveThruPickup', 'Drive-Thru Pickup');
    }
    return '';
};
export var generateHexId = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 24;
    return _.times(size, function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
};
export var serializeUtmData = function(utmData) {
    var serializedUtmData = utmData;
    // checks if utm data is an object, if not throw an error, then set the data to an empty object to not
    // interfere with checkout
    if (!_.isPlainObject(utmData)) {
        console.error('Bad UTM data shape:', utmData);
        serializedUtmData = {};
    }
    _.forEach(utmData, function(data, param) {
        if (!_.isString(data)) {
            var _data = _sliced_to_array(data, 1), newData = _data[0];
            serializedUtmData[param] = newData;
        }
    });
    return serializedUtmData;
};
export var isLowerCase = function(str) {
    return str === _.toLower(str);
};
export var removeAllSpecialCharactersWithoutDash = function(str) {
    return str.replace(/[^a-zA-Z0-9 -]/g, '');
};
// Remove diacritics from a string
// Previously, this function was defined using the `Diacritic` Unicode property, which is not supported in all environments.
// This version uses a more reliable method to remove diacritics.
export var removeDiacritics = function(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
